import { render } from "./FechaCita_Horario.vue?vue&type=template&id=2d81e6b4"
import script from "./FechaCita_Horario.vue?vue&type=script&lang=js"
export * from "./FechaCita_Horario.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__